import { resolveAssetUrl } from "../../services/apiConfig";
import { useState, useContext, useEffect } from "react";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHeart,
  faComment,
  faTrashCan,
} from "@fortawesome/free-regular-svg-icons";
import { AuthContext } from "../../context/AuthContext";
import { faCartShopping, faHeart as faHeartSolid } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import styles from "./PostModal.module.css";
import { FollowModal as LikeModal } from "../../components/modal/FollowModal";
import { useLike } from "../../hooks/useLike";
import { createComment } from "../../services/postService";
import { useComments } from "../../hooks/useComments";
import TextComposer from "../textComposer/TextComposer";

function PostModal({ isVisible, handleModal, post }) {
  const { user } = useContext(AuthContext);


  const [likes, setLike] = useState(post.likes.length || 0);
  const {
    comments,
    commentCount,
    isLoadingComments,
    commentsError,
    refreshComments,
    addComment,
  } = useComments(post);
  const [isLiked, setIsLiked] = useState(
    post.likes.some((like) => like.user_id === user.id)
  );
  const [isLikeModalVisible, setIsLikeModalVisible] = useState(false);

  const { animateHeart, updateLikes } = useLike();

  useEffect(() => {
    if (isVisible) refreshComments();
  }, [isVisible, refreshComments]);

  const closeModal = () => {
    handleModal(false);
  };

  const handleLikeModal = (value) => {
    setIsLikeModalVisible(value);
  };

  const submitComment = async (comment) => { try { const response = await createComment({ comment }, post.id, user.id); if (!response.success) throw new Error(response.message); addComment(response.comment); toast.success("Comentário adicionado com sucesso!"); } catch (error) { toast.error(error.message || "Algo deu errado! Tente novamente."); throw error; } };

  if (!isVisible) return null;

  return (
    user && (
      <div className={styles.modalBackdrop}>
        <div className={styles.modalContent}>
          <div className={styles.postContainer}>
            <div
              className={styles.postImageContainer}
              onDoubleClick={() =>
                updateLikes(isLiked, setIsLiked, setLike, post.id, user.id)
              }
            >
              <img src={resolveAssetUrl(post.image_url)} alt={post.id} />
              <FontAwesomeIcon
                icon={faHeartSolid}
                className={`${styles.heartIcon} ${
                  animateHeart ? styles.animate : ""
                }`}
              />
            </div>
            <div className={styles.postDetails}>
              <div className={styles.userDetails}>
                <div className={styles.accountImage}>
                  <img
                    src={
                      post.user.profile_url
                        ? resolveAssetUrl(post.user.profile_url)
                        : resolveAssetUrl("images/profile_image/user.png")
                    }
                    alt="Conta que comentou"
                  />
                </div>
                <Link to={`/profile/${post.user.username}`}>
                  <h1>{post.user.username}</h1>
                </Link>
                {user.id === post.user.id ? (
                  <FontAwesomeIcon
                    icon={faTrashCan}
                    className={styles.trashCan}
                  />
                ) : (
                  ""
                )}
              </div>
              <div className={styles.likeAndCommentIcons}>
                <FontAwesomeIcon
                  icon={isLiked ? faHeartSolid : faHeart}
                  className={isLiked ? styles.liked : ""}
                />
                <div
                  className={styles.likeCounts}
                  onClick={() => handleLikeModal(true)}
                >
                  {likes > 0 ? likes : ""}
                </div>
                <FontAwesomeIcon icon={faComment} />
                <div
                  className={styles.likeCounts}
                  onClick={() => handleLikeModal(true)}
                >
                  {commentCount > 0 ? commentCount : ""}
                </div>
                <Link className={styles.shoppingAction} to={"/posts/" + post.id + "/comprar"} onClick={closeModal} aria-label="Encontrar roupas similares para comprar"><FontAwesomeIcon icon={faCartShopping} /></Link>
                <LikeModal
                  isVisible={isLikeModalVisible}
                  handleModal={handleLikeModal}
                  users={post.likes}
                  heading={"Likes"}
                />
              </div>
              <div className={styles.captions}>{post.caption}</div>
              <hr />
              <div className={styles.commentList}>
                {isLoadingComments ? (
                  <p className={styles.commentsStatus} role="status">Carregando comentários...</p>
                ) : commentsError ? (
                  <p className={styles.commentsError} role="alert">{commentsError}</p>
                ) : comments.length === 0 ? (
                  <p className={styles.commentsStatus}>Ainda não há comentários.</p>
                ) : comments.map((comment) => (
                  <div className={styles.commentedAccount} key={comment.id}>
                    <div className={styles.accountDetails}>
                      <div className={styles.accountImage}>
                        <img
                          src={
                            comment.user.profile_url
                              ? resolveAssetUrl(comment.user.profile_url)
                              : resolveAssetUrl("images/profile_image/user.png")
                          }
                          alt="Conta que comentou"
                        />
                      </div>
                      <Link to={`/profile/${comment.user.username}`}>
                        <p className={styles.commentUsername}>
                          {comment.user.username}
                        </p>
                      </Link>
                    </div>
                    <p className={styles.commentDesc}>{comment.comment}</p>{" "}
                  </div>
                ))}
              </div>

              <div className={styles.comments}>
                <TextComposer onSubmit={submitComment} />
              </div>
            </div>
          </div>

          {/* Close Modal Button */}
          <button className={styles.closeButton} onClick={closeModal}>
            Fechar
          </button>
        </div>
      </div>
    )
  );
}

export { PostModal };
